<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="sapPurchaseOrderDetails/purchaseOrderDetail"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="otherBtn">
        <el-button v-if="createAuth" type="primary" @click="createDeliverySlip">创建送货单</el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="采购订单号">
            <el-input
                v-model.trim="filter.purchaseOrderNo"
                type="textarea"
                :autosize="{ minRows:1, maxRows:6 }"
                clearable/>
          </el-form-item>
          <el-form-item label="供应商名称">
            <el-input v-model.trim="filter.supplierName" clearable/>
          </el-form-item>
          <el-form-item label="采购组">
            <el-input v-model.trim="filter.buyUserName" clearable/>
          </el-form-item>
          <el-form-item label="物料号">
            <el-input v-model.trim="filter.partNo" clearable placeholder="单个模糊搜索"/>
          </el-form-item>
          <el-form-item label="物料号">
            <el-input v-model.trim="filter.partNos" clearable placeholder="多个批量搜索" type="textarea"/>
          </el-form-item>
          <el-form-item label="物料描述">
            <el-input v-model.trim="filter.partNameSpec" clearable/>
          </el-form-item>
          <el-form-item label="寄售">
            <el-select v-model="filter.consignment" clearable placeholder="请选择寄售">
              <el-option label="全部" value=""/>
              <el-option label="非寄售" value="非寄售"/>
              <el-option label="寄售" value="寄售"/>
            </el-select>
          </el-form-item>
          <el-form-item label="交期">
            <el-date-picker
                v-model="requireDeliveryDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('requireDeliveryDateRange', 'requireDeliveryDateBegin', 'requireDeliveryDateEnd')"/>
          </el-form-item>
          <el-form-item label="回复交期">
            <el-date-picker
                v-model="responseDeliveryTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('responseDeliveryTimeRange', 'responseDeliveryTimeBegin', 'responseDeliveryTimeEnd')"/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <purchase-receive-edit ref="purchaseReceiveEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import PurchaseReceiveEdit from "../PurchaseReceiveList/PurchaseReceiveEdit.vue";
  import loginUtil from "@/util/loginUtil";

  export default {
    name:"PurchaseOrderDetailList",
    components: {PurchaseReceiveEdit, viewTable},
    data() {
      return {
        limits: {
        },
        createAuth:this.$auth(426),
        requireDeliveryDateRange: [],
        responseDeliveryTimeRange: [],
        filter: {
          purchaseOrderNo:"",
          gysName:"",
          supplierName:"",
          partNo:"",
          partNos:"",
          partNameSpec:"",
          consignment:"",
          requireDeliveryDateBegin:"",
          requireDeliveryDateEnd:"",
          responseDeliveryTimeBegin:"",
          responseDeliveryTimeEnd:"",
          buyUserName:loginUtil.getName(),
          receiveStatus: -1,
          managerID:-1,
          production:-1,
          isFinished:1,
        },
        selection: [],
        materialType: [],
        columnsProperty: [
          {
            tooltip: true,
            key: "addDate",
            width: 200,
            align: "center",
          },
          {
            tooltip: true,
            key: "receiveStatusName",
            width: 120,
            align: "center",
          },
          {
            tooltip: true,
            key: "evaluate",
            width: 120,
            align: "center",
          },
          {
            tooltip: true,
            key: "rowNum",
            width: 80,
            align: "center",
          },
          {
            key: "supplierName",
            minWidth: 360,
            align: "center",
            tooltip: true,
          },
          {
            key: "supplierNo",
            width: 140,
            tooltip: true,
            align: "center",
          },
          {
            key: "buyUserName",
            width: 140,
            tooltip: true,
            align:"center",
          },
          {
            key: "partNo",
            width: 140,
            tooltip: true,
            align:"center",
          },
          {
            key: "partNo",
            width: 140,
            tooltip: true,
            align:"center",
          },
          {
            key: "partNameSpec",
            width: 140,
            tooltip: true,
            align:"center",
          },
          {
            key: "location",
            width: 140,
            tooltip: true,
            align:"center",
          },
          {
            key: "specification",
            width: 200,
            tooltip: true,
            align:"left",
          },
          {
            key: "purchasePlanQty",
            width: 140,
            tooltip: true,
            align:"center",
          },
          {
            key: "zsign",
            width: 140,
            tooltip: true,
            align:"center",
          },
          {
            key: "unit",
            width: 140,
            tooltip: true,
            align:"center",
          },
          {
            key: "unitPrice",
            width: 140,
            tooltip: true,
            align:"center",
          },
          {
            key: "Price",
            width: 140,
            tooltip: true,
            align:"center",
          },
          {
            key: "qty",
            width: 140,
            tooltip: true,
            align:"center",
          },
          {
            key: "hasInStorageQty",
            width: 140,
            tooltip: true,
            align:"center",
          },
          {
            key: "sumReceiveQty",
            width: 140,
            tooltip: true,
            align:"center",
          },
          {
            key: "requireDeliveryDate",
            width: 140,
            tooltip: true,
            align:"center",
          },
          {
            key: "responseDeliveryTime",
            width: 140,
            tooltip: true,
            align:"center",
          },
          {
            key: "consignment",
            width: 140,
            tooltip: true,
            align:"center",
          },
          {
            key: "urgent",
            width: 100,
            tooltip: true,
            align:"center",
          },
          {
            key: "remark",
            width: 140,
            tooltip: true,
            align:"center",
          },
        ],
      };
    },
    mounted() {
    },

    methods: {
      selectHandle(selection) {
        this.selection = selection;
      },


      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 创建送货单
      createDeliverySlip() {
        if (!this.selection.length) {
          this.$confirm("请选择采购订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          const result = this.selection.every((item) => item.supplierNo === this.selection[0].supplierNo);
          const location = this.selection.every((item) => item.location === this.selection[0].location);
          const consignment= this.selection.every((item) => item.consignment === this.selection[0].consignment);
          if (result  && location && consignment) {
            this.$refs.purchaseReceiveEdit.open(0, this.selection,true);
          } else if (!result) {
            this.$confirm("供应商不一致,请重新选择", "错误", {
              type: "error",
              showCancelButton: false,
            });
          } else if (!location) {
            this.$confirm("仓位不一致,请重新选择", "错误", {
              type: "error",
              showCancelButton: false,
            });
          } else if (!consignment) {
            this.$confirm("寄售类型不一致,请重新选择","错误",{
              type:"error",
              showCancelButton: false,
            });
          }

        }
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      resetHandle(filter) {
        this.filter = filter;
      },
    },
  };
</script>
